export enum EDialogAction {
  create = "create",
  view = "view",
  edit = "edit",
  delete = "delete",
  empty = "empty",
  recruitment = "recruitment",
}
